import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { lastValueFrom } from 'rxjs';
import { Injectable } from "@angular/core";
import { UserService } from "./user.service";
import { UtilityService } from "./utility.service";

@Injectable()
export class QuarriesService{
    
    constructor( private _http: HttpClient,private userSrv:UserService, private utilService:UtilityService ){}

    public getAll():Promise<any>{
        return new Promise((resolve,reject)=>{
            // const body = new HttpParams()
            // .set("setting",setting)
            // .set("username",this.userSrv.getUserName())
            // .set("token",this.userSrv.getUserToken())
            let result = lastValueFrom(this._http.get(this.utilService.getBaseUrl()+'Quarries/getall', ));
                result.then((data:any)=>{
                    resolve(data)
                }).catch((error)=>{
                    console.log(error);
                    reject(error);
                })
        });
    }

    private postRequest(url:string, body:HttpParams){
        return this._http.post(url,body.toString(),{headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')})
    }
}